module.exports = __webpack_public_path__ + "static/media/path03.6c284737.png";